import { env } from '../env';

export const DISPLAY_STEP = 5;

// Purchase states
export const STATE_PENDING = 1;
export const STATE_VALID = 2;
export const STATE_INVALID = 4;

// estimated number of days to validate a payment request
export const PAYMENT_DELAY = 21;

// Payment request states
export const PAYMENT_REQUEST_STATE_UNPROCESSED = 0;
export const PAYMENT_REQUEST_STATES_PENDING = [0, 1, 2];
export const PAYMENT_REQUEST_STATES_VALID = [3];
export const PAYMENT_REQUEST_STATES_INVALID = [4, 5];

// Payment request types
export const PAYMENT_REQUEST_TYPE_EBON_ORDER = Number(env.REACT_APP_PAYMENT_REQUEST_EBON_TYPE);
export const PAYMENT_REQUEST_TYPE_DON = Number(env.REACT_APP_PAYMENT_REQUEST_TYPE_ASSO);



// WEBPACK FOOTER //
// ./src/constants/payment.js